class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    document.dispatchEvent(new CustomEvent("globo.preorder.collection.filter",{
        detail: {}
    }))


    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) 
      loadMore();
    
    colorSwatches();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    
    // Date: 14/02/2025
    // As per the requiremnet, Dishwasher safe, Oven safe, Freezer safe and Microwave safe - Yes - values are combined to display under "Product Use" facet section. 
    // By default, the "Current Selected Facet Values" section does not refresh. I have updated it so that the "Current Facet Selection Values" section also refreshes. Please review the changes in the code comments below.
    
    const facetsToRender = Array.from(facetDetailsElements);
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
       
    facetsToRender.forEach((element) => {      
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;            
    });              

    facetsToRender.forEach((element) => {      
      if(element.dataset.index == 30) {
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML; 
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
    // Sync checkboxes after rendering
    FacetFiltersForm.syncFacetCheckboxes();
  }

  // Add the missing renderCounts method to avoid runtime errors
  static renderCounts(countsToRender, targetFilter) {
    if (!countsToRender || !targetFilter) return;
    targetFilter.innerHTML = countsToRender.innerHTML;
  }

  // Synchronize checkbox states between horizontal and normal facets
  static syncFacetCheckboxes() {
    const allCheckboxes = document.querySelectorAll('input[type="checkbox"][name^="filter"]');

    // Add change listeners to sync checkboxes with same name/value
    allCheckboxes.forEach(checkbox => {
      // Remove existing listener to avoid duplicates
      checkbox.removeEventListener('change', FacetFiltersForm.handleCheckboxSync);
      // Add new listener
      checkbox.addEventListener('change', FacetFiltersForm.handleCheckboxSync);
    });
  }

  static handleCheckboxSync(event) {
    const changedCheckbox = event.target;
    
    // Prevent infinite loops
    if (changedCheckbox.dataset.syncing === 'true') {
      return;
    }
    
    // Find and sync all checkboxes with matching name and value
    const allCheckboxes = document.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(changedCheckbox.name)}"][value="${CSS.escape(changedCheckbox.value)}"]`);
    
    allCheckboxes.forEach(checkbox => {
      if (checkbox !== changedCheckbox && !checkbox.disabled) {
        // Mark as syncing to prevent infinite loops
        checkbox.dataset.syncing = 'true';
        checkbox.checked = changedCheckbox.checked;
        // Remove syncing flag
        setTimeout(() => delete checkbox.dataset.syncing, 0);
      }
    });
    
    // Trigger custom event for horizontal facet visibility updates
    document.dispatchEvent(new CustomEvent('facet-checkbox-synced'));
  }

    // Date: 14/02/2025
  // As per the requirement, the empty facets section should be hidden.  
  static updateDetailsVisibility({
    selector,
    itemClass,
    labelDisabledClass,
    excludedParentClasses
  }) {
      document.querySelectorAll(selector).forEach(detailsTag => {        
          const parentElement = detailsTag.parentElement;          
          // Skip if the parent contains all excluded classes
          if (
              parentElement &&
              excludedParentClasses.every(cls => parentElement.classList.contains(cls))
          ) {
              return;
          }

          // Check if at least one <label> is not disabled
          const listItems = detailsTag.querySelectorAll(itemClass);
          const hasEnabledLabel = Array.from(listItems).some(item => {
              const label = item.querySelector('label');
              return label && !label.classList.contains(labelDisabledClass);
          });

          // Show or hide the <details> tag based on the presence of enabled labels
          detailsTag.style.display = hasEnabledLabel ? '' : 'none';
      });
  }
  
  static renderActiveFacets(html) {
    let activeFacetsElement = document.querySelector('.active-facets');
    let facetWrapper =  document.querySelector('.active-facets__wrapper');
    if(facetWrapper) {
      // Check if the element is the only child of its parent
      if (activeFacetsElement && activeFacetsElement.children.length > 1) {
        facetWrapper.classList.add('show-active-facets');
      } else {
        facetWrapper.classList.remove('show-active-facets');
      }
    }

    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);

        // Configurations for facets and mobile facets
    FacetFiltersForm.updateDetailsVisibility({
      selector: '.facets__disclosure.js-filter',
      itemClass: '.facets__item',
      labelDisabledClass: 'facet-checkbox--disabled',
      excludedParentClasses: ['active-facets__wrapper', 'hide-facets', 'active-facets-desktop']
    });

    FacetFiltersForm.updateDetailsVisibility({
      selector: '.mobile-facets__details.js-filter',
      itemClass: '.mobile-facets__item',
      labelDisabledClass: 'mobile-facets__label--disabled',
      excludedParentClasses: ['active-facets__wrapper', 'hide-facets', 'active-facets-desktop']
    });
    
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }


  // Static method to update title from url based on color filter
  static getUrlParameters(name) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)', 'g');
    let results = [];
    let match;
    while (match = regex.exec(location.search)) {
      results.push(decodeURIComponent(match[1].replace(/\+/g, ' ')));
    }
    return results;
  }
  

  // Static method to update title based on color filter
  static updateTitle() {
    let urlParams = new URLSearchParams(window.location.search);
    let facetColors = this.getUrlParameters("filter.p.m.restaurantware.facet_color");
    let titleElement = document.getElementById("collection-hero__title");
    let metaTag = document.querySelector('meta[name="robots"]');    
    if (typeof collectionBannerTitle !== "undefined") {
      if (facetColors.length === 1 && urlParams.size === 1) {
        titleElement.innerText = facetColors[0] + " " + collectionBannerTitle;
        // Update meta tag content for Index, Follow
        if (metaTag) {
          metaTag.content = "index, follow";
        }
      } 
      else {
        titleElement.innerText = collectionBannerTitle;
        // Update meta tag content for noindex, nofollow
        if (metaTag) {
          metaTag.content = "noindex, nofollow";
        }
      }
    }
  }

  static updateURLHash(searchParams) {
    const defaultSortParam = 'sort_by=best-selling';
    const hasDefaultSort = searchParams.includes(defaultSortParam);
    // If the default sort parameter is present, exclude it from the URL
    const updatedSearchParams = hasDefaultSort ? searchParams.replace(defaultSortParam, '') : searchParams;
    // Update the URL
    history.pushState({ searchParams: updatedSearchParams }, '', `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`);
    FacetFiltersForm.updateTitle();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const closestForm = event.target.closest('form');
      const isMobile = closestForm && closestForm.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm' || form.id === 'HorizontalFacetFiltersForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}


FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Prevent scroll when clicking horizontal facet labels using event delegation on document
// This ensures it works even after DOM is re-rendered
(function() {
  // Use event delegation on document - this never needs to be re-attached
  document.addEventListener('click', function(event) {
    const label = event.target.closest('label.facet-checkbox');
    if (!label) return;
    
    // Check if this label is inside a horizontal facet container
    const horizontalContainer = label.closest('.horizontal-facets-container, .horizontal_facets__container, .horizontal_facet-container');
    if (!horizontalContainer) return;
    
    // Get the checkbox associated with this label
    const forAttr = label.getAttribute('for');
    const checkbox = forAttr ? document.getElementById(forAttr) : label.querySelector('input[type="checkbox"]');
    
    if (checkbox && !checkbox.disabled) {
      // Prevent the default label behavior which causes scroll
      event.preventDefault();
      event.stopPropagation();
      
      // Manually toggle the checkbox
      checkbox.checked = !checkbox.checked;
      
      // Dispatch change event to trigger the filter update
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Also dispatch input event for the form handler
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }, true); // Capture phase to intercept before default behavior
})();

// Initialize checkbox synchronization on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => FacetFiltersForm.syncFacetCheckboxes());
} else {
  FacetFiltersForm.syncFacetCheckboxes();
}
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    inputRangeWrappers.forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = fromCurrent / range * 100;
      const maxRange = toCurrent / range * 100;

      inputWrapper.setAttribute(
        'style',
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    })
  }

  controlSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.field__input')[1];

      inputRangeFrom.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        }
        else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      }

      if (Number(inputRangeTo.value) <= 0 ) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0 ) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      }
    })
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll('.field__input');
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

      inputNumberFrom.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } 
        else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      }

      inputNumberTo.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
        }

        this.fillSlider();
      }

    })
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink?.setAttribute('role', 'button');
    facetLink?.addEventListener('click', this.closeFilter.bind(this));
    facetLink?.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

document.addEventListener("DOMContentLoaded", function () {

  function updateFacetReset(){

    const facets = document.querySelectorAll('#FacetsWrapperDesktop>details');

    const reset = document.querySelectorAll('.facets__summary .facets__summary-inner facet-remove');

        facets.forEach((facet, index) => {
          const checkboxes = facet.querySelectorAll('input[type="checkbox"]');
          let isChecked = false;

          // Loop through each checkbox inside the current facet
          checkboxes.forEach(checkbox => {
              if (checkbox.checked) {
                  isChecked = true;
              }
          });

          // Show or hide the reset button based on whether any checkbox is checked
          if (isChecked) {
              reset[index+1].style.display = 'block'; // Show reset button
          } else {
              reset[index+1].style.display = 'none'; // Hide reset button
          }
      });

  }

  updateFacetReset();

  const addressContainer = document.querySelector('#FacetsWrapperDesktop');

        if (addressContainer) {
          const observer = new MutationObserver(function (mutations) {
              mutations.forEach(function (mutation) {
                  if (mutation.type === 'childList' && addressContainer.contains(mutation.target)) {
                    updateFacetReset();  // Call your function after the address is added
                  }
              });
          });

          // Observe the child changes of the address container
          observer.observe(addressContainer, {
              childList: true,  // Listen for added or removed children
              subtree: true      // Observe all descendants, not just direct children
          });
        }
});

document.addEventListener('DOMContentLoaded', () => {
  FacetFiltersForm.updateDetailsVisibility({
    selector: '.facets__disclosure.js-filter',
    itemClass: '.facets__item',
    labelDisabledClass: 'facet-checkbox--disabled',
    excludedParentClasses: ['active-facets__wrapper', 'hide-facets', 'active-facets-desktop']
  });

  FacetFiltersForm.updateDetailsVisibility({
    selector: 'details.mobile-facets__details.js-filter',
    itemClass: '.mobile-facets__item',
    labelDisabledClass: 'mobile-facets__label--disabled',
    excludedParentClasses: ['active-facets__wrapper', 'hide-facets', 'active-facets-desktop']
  });
});